import { CANVAS_FORM_CHANGED, CANVAS_GUIDE_CURRENT_STEP, CANVAS_HOLES_CHANGED, CANVAS_OBJECT_ADDED, CANVAS_OBJECT_REMOVED, CANVAS_SELECTION_MODIFIED, CANVAS_TYPE_CHANGED, MENU_OPTION_SELECTED, OBJECT_CHANGED, UPDATE_CANVAS_SIZE, RESET_CANVAS, INITIALIZE_FROM_SIGN, CANVAS_TEXT_PROPERTY_CHANGED, SHOW_PRODUCT_TEMPLATE_EDIT_MODAL, UNLOCK_CANVAS_EDITING, LOCK_CANVAS_EDITING, UNDO_ACTION, REDO_ACTION, IS_UNDO_REDO_ENABLED, SAVE_CANVAS_STATE, CLEAR_HISTORY, CANVAS_OBJECT_COUNT_CHANGED, CANVAS_PRICE_CHANGED, CANVAS_PRICE_RERENDERED, WINDOW_RESIZED, SNAPPING_TOGGLED, } from '../../Rutab/RutabConstants';
import { sizes } from '../../Editor/DecalEditorCanvasSizing';
import { translate } from '../../Services/translation';
const initialState = {
    menuOption: null,
    canvas: null,
    canvasRef: null,
    canvasSize: {
        sizeKey: 'A5',
        width: sizes.A5.width,
        height: sizes.A5.height,
        orientation: 'portrait',
    },
    objectCount: 0,
    activeSelection: [],
    selectedForm: {
        formKey: 'none-form',
        formName: translate('decal.shapemenu.type.none.label'),
    },
    holePlacement: 'none',
    activeObjectLocationChanged: null,
    canvasType: null,
    decalGuide: null,
    resetCanvas: false,
    canvasTextProperty: {
        fontSize: 48,
        text: 'Hej!'
    },
    isEditingLocked: false,
    showProductTemplateEditModal: false,
    historyState: {
        history: [],
        historyObjects: [],
        currentIndex: -1,
    },
    isUndoRedoEnabled: false,
    isUndoRedoInProgress: false,
    canvasPrice: 0,
    canvasPriceRerendered: false,
    windowResized: false,
    snappingEnabled: true,
};
export const decalEditor = (state = initialState, action) => {
    switch (action.type) {
        case MENU_OPTION_SELECTED:
            return Object.assign(Object.assign({}, state), { menuOption: action.payload.menuOption === null
                    ? null
                    : Object.assign(Object.assign({}, state.menuOption), action.payload.menuOption) });
        case CANVAS_GUIDE_CURRENT_STEP:
            return Object.assign(Object.assign({}, state), { decalGuide: action.payload.decalGuide === null
                    ? null
                    : Object.assign(Object.assign({}, state.decalGuide), action.payload.decalGuide) });
        case UPDATE_CANVAS_SIZE:
            return Object.assign(Object.assign({}, state), { canvasSize: Object.assign(Object.assign({}, state.canvasSize), action.payload.canvasSize) });
        case CANVAS_SELECTION_MODIFIED:
            return Object.assign(Object.assign({}, state), { activeSelection: [...action.payload.activeSelection] });
        case CANVAS_OBJECT_ADDED:
            return Object.assign(Object.assign({}, state), { objectCount: state.objectCount + 1 });
        case CANVAS_OBJECT_REMOVED:
            return Object.assign(Object.assign({}, state), { objectCount: state.objectCount - 1 });
        case CANVAS_OBJECT_COUNT_CHANGED:
            return Object.assign(Object.assign({}, state), { objectCount: action.payload.objectCount });
        case CANVAS_FORM_CHANGED:
            return Object.assign(Object.assign({}, state), { selectedForm: action.payload.canvasForm });
        case CANVAS_HOLES_CHANGED:
            return Object.assign(Object.assign({}, state), { holePlacement: action.payload.holePlacement });
        case CANVAS_TYPE_CHANGED:
            return Object.assign(Object.assign({}, state), { canvasType: action.payload.canvasType });
        case OBJECT_CHANGED:
            return Object.assign(Object.assign({}, state), { activeObjectLocationChanged: action.payload.activeObjectLocationChanged });
        case RESET_CANVAS:
            return Object.assign(Object.assign({}, state), { objectCount: 0, menuOption: null, canvasType: action.payload.defaultCanvasType || state.canvasType, canvasSize: {
                    sizeKey: 'A5',
                    width: sizes.A5.width,
                    height: sizes.A5.height,
                    orientation: 'portrait',
                }, selectedForm: {
                    formKey: 'none-form',
                    formName: 'Ingen / Kvadrat',
                }, holePlacement: 'none', activeSelection: [], resetCanvas: !state.resetCanvas, isEditingLocked: false, historyState: {
                    history: [],
                    currentIndex: -1,
                } });
        case INITIALIZE_FROM_SIGN:
            const { canvasSize, canvasType, canvasForms, objectCount, holePlacement } = action.payload;
            return Object.assign(Object.assign({}, state), { canvasSize,
                canvasType, selectedForm: canvasForms, objectCount,
                holePlacement });
        case CANVAS_TEXT_PROPERTY_CHANGED:
            return Object.assign(Object.assign({}, state), { canvasTextProperty: action.payload.canvasTextProperty });
        case SHOW_PRODUCT_TEMPLATE_EDIT_MODAL:
            return Object.assign(Object.assign({}, state), { showProductTemplateEditModal: action.payload.showProductTemplateEditModal });
        case UNLOCK_CANVAS_EDITING:
            return Object.assign(Object.assign({}, state), { isEditingLocked: false });
        case LOCK_CANVAS_EDITING:
            return Object.assign(Object.assign({}, state), { isEditingLocked: true });
        case UNDO_ACTION:
            return Object.assign(Object.assign({}, state), { historyState: action.payload.historyState || state.historyState, isUndoRedoInProgress: action.payload.isUndoRedoInProgress !== undefined
                    ? action.payload.isUndoRedoInProgress
                    : state.isUndoRedoInProgress });
        case REDO_ACTION:
            return Object.assign(Object.assign({}, state), { historyState: action.payload.historyState || state.historyState, isUndoRedoInProgress: action.payload.isUndoRedoInProgress !== undefined
                    ? action.payload.isUndoRedoInProgress
                    : state.isUndoRedoInProgress });
        case SAVE_CANVAS_STATE:
            return Object.assign(Object.assign({}, state), { historyState: action.payload.historyState });
        case CLEAR_HISTORY:
            return Object.assign(Object.assign({}, state), { historyState: action.payload.historyState });
        case IS_UNDO_REDO_ENABLED:
            return Object.assign(Object.assign({}, state), { isUndoRedoEnabled: action.payload.isUndoRedoEnabled });
        case CANVAS_PRICE_CHANGED:
            return Object.assign(Object.assign({}, state), { canvasPrice: action.payload.canvasPrice });
        case CANVAS_PRICE_RERENDERED:
            return Object.assign(Object.assign({}, state), { canvasPriceRerendered: !state.canvasPriceRerendered });
        case WINDOW_RESIZED:
            return Object.assign(Object.assign({}, state), { windowResized: !state.windowResized });
        case SNAPPING_TOGGLED:
            return Object.assign(Object.assign({}, state), { snappingEnabled: !state.snappingEnabled });
        default:
            return state;
    }
};
